/* ============================================================
   Fuji Hydration - sticky AJAX buy bar
   Vanilla, no dependencies, loaded with defer.

   Independent of the page-builder / personalization SDK on purpose:
   if that bundle never runs, add-to-cart from this bar still works.
   ============================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-buy-bar]');
  if (!bar) return;

  var addBtn   = bar.querySelector('[data-sbb-add]');
  var variantEl= bar.querySelector('[data-sbb-variant]');
  var priceEl  = bar.querySelector('[data-sbb-price]');
  var msgEl    = bar.querySelector('[data-sbb-msg]');
  var confirmEl= bar.querySelector('[data-sbb-confirm]');
  if (!addBtn) return;

  var directCheckout = bar.getAttribute('data-direct-checkout') === 'true';
  var idleLabel = addBtn.textContent;
  var busy = false;                       // double-tap protection
  var variants = [];
  try { variants = JSON.parse(bar.querySelector('[data-sbb-variants]').textContent); } catch (e) {}

  /* ---------- helpers ---------- */

  function money(cents) {
    // Reuse the theme's formatter when theme.js has published one.
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function say(text, isError) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
    msgEl.classList.toggle('is-error', !!isError);
  }

  function currentVariant() {
    var id = variantEl ? variantEl.value : bar.getAttribute('data-variant-id');
    return variants.filter(function (v) { return String(v.id) === String(id); })[0] || variants[0];
  }

  function setLoading(on) {
    busy = on;
    addBtn.disabled = on;
    addBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    addBtn.textContent = on ? (bar.getAttribute('data-loading-label') || 'Adding…') : idleLabel;
  }

  /* Carry over anything the main product form is holding: quantity, line-item
     properties and a selling plan. This theme ships none of the latter two
     today, but reading them here means an app or a future edit that adds them
     will not silently lose them through this bar. */
  function extras() {
    var out = { quantity: 1 };
    var form = document.querySelector('[data-product-form]');
    if (!form) return out;

    var qty = form.querySelector('[name="quantity"]');
    if (qty && parseInt(qty.value, 10) > 0) out.quantity = parseInt(qty.value, 10);

    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && plan.value) out.selling_plan = plan.value;

    var props = {};
    var found = false;
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (el.type === 'checkbox' && !el.checked) return;
      if (el.type === 'radio' && !el.checked) return;
      var key = el.name.slice(11, -1);
      if (!key) return;
      props[key] = el.value;
      found = true;
    });
    if (found) out.properties = props;

    return out;
  }

  /* ---------- add to cart ---------- */

  function add() {
    if (busy) return;                     // exactly one add per click
    var v = currentVariant();
    if (!v) return;
    if (v.available === false) { say('That option is sold out.', true); return; }

    say('');
    setLoading(true);

    var payload = extras();
    payload.id = v.id;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [payload] })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;          // 422 sold out / unavailable
          return body;
        });
      })
      .then(function () {
        if (directCheckout && bar.getAttribute('data-then') === 'checkout') {
          window.location.assign('/checkout');
          return;                         // leave the button in its loading state
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (c) {
              c.textContent = cart.item_count;
            });
            setLoading(false);

            // Reuse the theme's existing drawer rather than introducing a second cart UI.
            if (window.theme && typeof window.theme.openCart === 'function') {
              window.theme.openCart();
            } else if (confirmEl) {
              confirmEl.hidden = false;
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
      })
      .catch(function (err) {
        setLoading(false);
        var m = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.';
        say(String(m).replace(/<[^>]*>/g, ''), true);
      });
  }

  addBtn.addEventListener('click', function (e) { e.preventDefault(); add(); });

  if (variantEl) {
    variantEl.addEventListener('change', function () {
      var v = currentVariant();
      if (!v) return;
      say('');
      if (priceEl && typeof v.price === 'number') priceEl.textContent = money(v.price);
      addBtn.disabled = v.available === false;
      idleLabel = v.available === false ? 'Sold out' : bar.getAttribute('data-label');
      addBtn.textContent = idleLabel;
    });
  }

  /* ---------- reveal: IntersectionObserver on the main buy button ---------- */

  var anchors = document.querySelectorAll(bar.getAttribute('data-anchor-selector') || '[data-add-btn]');

  function show() { bar.hidden = false; requestAnimationFrame(function () { bar.classList.add('is-visible'); }); }
  function hide() { bar.classList.remove('is-visible'); }

  if (!anchors.length) {
    // Nothing to anchor to (e.g. a landing page with no inline buy button):
    // reveal once the user has scrolled a screen's worth.
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:100vh;height:1px;width:1px;pointer-events:none;';
    document.body.appendChild(sentinel);
    anchors = [sentinel];
  }

  if ('IntersectionObserver' in window) {
    var seen = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      var anyVisible = false;
      anchors.forEach(function (a) { if (seen.get(a)) anyVisible = true; });
      if (anyVisible) hide(); else show();
    }, { threshold: 0 });
    anchors.forEach(function (a) { io.observe(a); });
  } else {
    show();
  }

  bar.querySelectorAll('[data-sbb-dismiss]').forEach(function (el) {
    el.addEventListener('click', function () { bar.hidden = true; });
  });
})();

/* ============================================================
   Change 2b - one-tap "Buy now".

   Only binds if sections/main-product.liquid actually rendered a
   [data-buy-now] button (buy_now_mode = "direct"). The dynamic-checkout
   option needs no JS at all - Shopify's payment button is already one tap.

   Deliberately in this file, not theme.js and not the personalization
   bundle, so the buy path is independent of both.
   ============================================================ */
(function () {
  'use strict';

  var btn = document.querySelector('[data-buy-now]');
  if (!btn) return;

  var form = btn.closest('form[action$="/cart/add"]') || document.querySelector('[data-product-form]');
  if (!form) return;

  var msgEl = document.querySelector('[data-buy-now-msg]');
  var idle = btn.getAttribute('data-label') || btn.textContent;
  var direct = btn.getAttribute('data-direct-checkout') !== 'false';
  var busy = false;

  function say(text) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
  }

  function payload() {
    var item = { quantity: 1 };

    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return null;
    item.id = id.value;

    var qty = form.querySelector('[name="quantity"]');
    if (qty && parseInt(qty.value, 10) > 0) item.quantity = parseInt(qty.value, 10);

    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && plan.value) item.selling_plan = plan.value;

    var props = {}, found = false;
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var key = el.name.slice(11, -1);
      if (!key) return;
      props[key] = el.value;
      found = true;
    });
    if (found) item.properties = props;

    return item;
  }

  btn.addEventListener('click', function (e) {
    // type="button", so no form submit fires - but stop it explicitly anyway.
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;                       // exactly one add per click

    var item = payload();
    if (!item) return;

    busy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding\u2026';
    say('');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;            // 422: sold out / unavailable
          return body;
        });
      })
      .then(function () {
        if (direct) {
          btn.textContent = 'Going to checkout\u2026';
          window.location.assign('/checkout');
          return;                           // stay latched; the page is leaving
        }
        busy = false;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = idle;
        if (window.theme && typeof window.theme.openCart === 'function') window.theme.openCart();
      })
      .catch(function (err) {
        busy = false;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = idle;
        var m = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.';
        say(String(m).replace(/<[^>]*>/g, ''));
      });
  });
})();
